export const settingsSubMenuLinks = [
  {
    id: 1,
    linkTo: 'jurisdiction',
    name: 'Jurisdiction',
  },
  {
    id: 2,
    linkTo: 'trades',
    name: 'Trades',
  },
  {
    id: 3,
    linkTo: 'documents',
    name: 'Documents',
  },
  {
    id: 4,
    linkTo: 'fees',
    name: 'Fees',
  },
  {
    id: 5,
    linkTo: 'scheduling',
    name: 'Scheduling',
  },
  {
    id: 6,
    linkTo: 'activities',
    name: 'Activities',
  },
  {
    id: 7,
    linkTo: 'inspection-type',
    name: 'Inspection Type',
  },
  {
    id: 8,
    linkTo: 'contact-type',
    name: 'Contact Type',
  },
  {
    id: 9,
    linkTo: 'report-setup',
    name: 'Report Setup',
  },
  {
    id: 10,
    linkTo: 'vocabulary',
    name: 'Vocabulary',
  },
  {
    id: 11,
    linkTo: 'messages',
    name: 'Messages',
  },
  {
    id: 12,
    linkTo: 'reference-codes',
    name: 'Reference Codes',
  },
  {
    id: 13,
    linkTo: 'message-day',
    name: 'Message Setup',
  },
  {
    id: 14,
    linkTo: 'special-permission',
    name: 'Special Permission',
  },
  {
    id: 15,
    linkTo: 'global-variables',
    name: 'Global Variables',
  },
];

// BreadCrumbs derives each crumb from its URL slug via capitalCase, which is
// already correct for nearly every route ('reference-codes' -> 'Reference
// Codes'). List a slug here only when its display name genuinely differs from
// the slug, and keep it in sync with the tab label above.
//
// Deliberately NOT auto-derived from the menu arrays: 'report-setup' is named
// 'Report Setup' in settingsSubMenuLinks but 'Reports' in settingsSetupLinks,
// so a generated map would silently rename that crumb too.
export const BREADCRUMB_LABEL_OVERRIDES: Record<string, string> = {
  'message-day': 'Message Setup',
};

export const settingsSetupLinks = [
  {
    id: 1,
    linkTo: 'report-setup',
    name: 'Reports',
  },
  {
    id: 2,
    linkTo: 'form-setup',
    name: 'Forms',
  },
  {
    id: 3,
    linkTo: 'inspection-form-builder',
    name: 'Form Builder',
  },
];

export const reportsSubMenuLinks = [
  {
    id: 1,
    linkTo: 'sales',
    name: 'Sales',
  },
];

export const franchiseSubMenuLinks = [
  {
    id: 1,
    linkTo: 'jurisdiction',
    name: 'Jurisdiction',
  },
  {
    id: 2,
    linkTo: 'users',
    name: 'Users',
  },
  {
    id: 3,
    linkTo: 'stripe',
    name: 'Stripe',
  },
];

export interface SubMenuLink {
  linkTo: string;
  name: string;
  id: number;
}

export const Logo_Gold = '#D2B96D';
export const Logo_Sky = '#316B99';
export const Logo_Blue = '#0C1341';
export const Logo_Grey = '#7E8D8C';
